import React from "react";

import { Modal } from "antd";
import { Field, FieldProps, Formik } from "formik";

import api from "../../../services/api";
import { notifyError, notifySucces } from "../../../utils/notifications";
import { TextArea } from "../../TextArea";
import {
  DESCRIPTION_MAX_LENGTH,
  newTimelineItemSchema,
  OBSERVATION_MAX_LENGTH,
  TimelineItemSchema,
} from "./schema";
import * as S from "./style";

type NewTimelineItemModalProps = {
  onClose: () => void;
  isOpen: boolean;
  clientId: number;
  onSuccess: () => void;
};

export function NewTimelineItemModal({
  onClose,
  isOpen,
  clientId,
  onSuccess,
}: NewTimelineItemModalProps) {
  const handleSubmit = async ({
    values,
    setSubmitting,
  }: {
    values: TimelineItemSchema;
    setSubmitting: (isSubmitting: boolean) => void;
  }) => {
    try {
      setSubmitting(true);
      await api.post("timeline", {
        description: `Inc. Manual: ${values.description}`,
        client_id: clientId,
        obs: values.observation,
      });
      notifySucces("Inclusão manual criada com sucesso!");
      onSuccess();
    } catch (e) {
      const error = e as ErrorMessage;
      notifyError(`Houve um erro ao criar a inclusão manual: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Inclusão Manual no Histórico de Atendimento SAC"
      visible={isOpen}
      onCancel={onClose}
      destroyOnClose
    >
      <Formik
        initialValues={{
          description: "",
          observation: "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          handleSubmit({ values, setSubmitting });
        }}
        onReset={() => {
          onClose();
        }}
        validationSchema={newTimelineItemSchema}
      >
        {({ handleSubmit, handleReset, isSubmitting }) => (
          <S.FormWapper onSubmit={handleSubmit} onReset={handleReset}>
            <Field name="description">
              {({ field, meta }: FieldProps<string>) => (
                <TextArea
                  label="Descrição"
                  value={field.value}
                  onChange={field.onChange}
                  error={meta.error}
                  maxLength={DESCRIPTION_MAX_LENGTH}
                  name={field.name}
                  onBlur={field.onBlur}
                  isRequired
                />
              )}
            </Field>
            <Field name="observation">
              {({ field, meta }: FieldProps<string>) => (
                <TextArea
                  label="Observação"
                  value={field.value}
                  onChange={field.onChange}
                  error={meta.error}
                  maxLength={OBSERVATION_MAX_LENGTH}
                  name={field.name}
                  onBlur={field.onBlur}
                />
              )}
            </Field>
            <S.ButtonsWrapper>
              <S.CancelButton type="reset" disabled={isSubmitting}>
                Cancelar
              </S.CancelButton>
              <S.SubmitButton type="submit" disabled={isSubmitting}>
                {isSubmitting && <S.Loader />}Confirmar
              </S.SubmitButton>
            </S.ButtonsWrapper>
          </S.FormWapper>
        )}
      </Formik>
    </Modal>
  );
}
